/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_TitleInputs */

const en_price_page_faq_title = /** @type {(inputs: Price_Page_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions about money`)
};

const pl_price_page_faq_title = /** @type {(inputs: Price_Page_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytania o pieniądze`)
};

/**
* | output |
* | --- |
* | "Questions about money" |
*
* @param {Price_Page_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_title = /** @type {((inputs?: Price_Page_Faq_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_title(inputs)
	return en_price_page_faq_title(inputs)
});